import $ from "jquery";

export function initShared() {
    $(".mobile-menu-btn").on("click", function() {
        $(".mobile-menu").toggle();
    });

    $(".nav ul li a").on("click", function(e) {
        const goto = $(this).data("anchor");
        $("html,body")
            .stop()
            .animate({ scrollTop: $(goto).offset().top - 80 }, 1000);
        e.preventDefault();
    });

    $(".lang-active").on("click", function() {
        $(".lang-variant").toggle();
        $(".lang-active, .lang-variant").toggleClass("active");

        $(document).on("mouseup", function(e) {
            const container = $("#container");
            if (
                !container.is(e.target) &&
                container.has(e.target).length === 0
            ) {
                $(".lang-variant").hide();
                $(".lang-active, .lang-variant").removeClass("active");
            }
        });
    });

    $(".number .number_controls > div").on("click", function() {
        const input = $(this).closest(".number").find("input"); // инпут
        let value = parseInt(input.val()) || 0; // получаем value инпута или 0
        if ($(this).hasClass("nc-minus")) {
            value = value - 1; // вычитаем из value 1
        }
        if ($(this).hasClass("nc-plus")) {
            value = value + 1; // прибавляем к value 1
        }
        input.val(value).change(); // выводим полученное value в инпут; триггер .change() - на случай, если на изменение этого инпута у вас уже объявлен еще какой-то обработчик
    });

    $(".spoiler-title").on("click", function() {
        $(this).next(".spoiler-content").slideToggle();
        $(this).find("img").toggleClass("spoiler-rotate");
    });

    $(function() {
        $("ul.tabs__caption").on("click", "li:not(.active)", function() {
            $(this)
                .addClass("active")
                .siblings()
                .removeClass("active")
                .closest("div.tabsw")
                .find("div.tabs__content")
                .removeClass("active")
                .eq($(this).index())
                .addClass("active");
        });
    });

    $(".notification-btn-ok").on("click", function() {
        const date = new Date();
        date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
        const expires = "; expires=" + date.toUTCString();
        document.cookie = "cookie_policy=1" + expires + "; path=/";
        $("#cookie-policy").remove();
    });
}
